import { Icons } from '@commenda/kakashi';

import { IndirectTaxFilingsStatusVerdict } from '../helpers';

interface IndirectTaxFilingsStatusIconProps {
  verdict: IndirectTaxFilingsStatusVerdict;
}

/**
 * Tiny presentational component that maps a verdict to its icon. Lives next
 * to the modal because the modal is the only consumer; lifted out of inline
 * `createElement` calls so the helper class stays pure (no React rendering
 * inside `helpers/`).
 */
const IndirectTaxFilingsStatusIcon = ({
  verdict,
}: IndirectTaxFilingsStatusIconProps) => {
  switch (verdict) {
    case IndirectTaxFilingsStatusVerdict.IN_PROGRESS:
      return (
        <Icons.Loading01 className="size-4 animate-spin text-utility-blue-500" />
      );
    case IndirectTaxFilingsStatusVerdict.COMPLETED:
      return <Icons.CheckCircle className="size-4 text-text-success" />;
    case IndirectTaxFilingsStatusVerdict.FAILED:
      return <Icons.XCircle className="size-4 text-text-error" />;
    case IndirectTaxFilingsStatusVerdict.NO_FILINGS:
      return <Icons.CheckCircle className="size-4 text-utility-gray-400" />;
    case IndirectTaxFilingsStatusVerdict.NOT_STARTED:
    default:
      return <Icons.Circle className="size-4 text-text-tertiary" />;
  }
};

export { IndirectTaxFilingsStatusIcon };
